'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var GET_LIST = exports.GET_LIST = 'GET_LIST';
var GET_ONE = exports.GET_ONE = 'GET_ONE';
var GET_MANY = exports.GET_MANY = 'GET_MANY';
var GET_MANY_REFERENCE = exports.GET_MANY_REFERENCE = 'GET_MANY_REFERENCE';
var CREATE = exports.CREATE = 'CREATE';
var UPDATE = exports.UPDATE = 'UPDATE';
var DELETE = exports.DELETE = 'DELETE';


//////////////////
// WEBPACK FOOTER
// ./~/admin-on-rest/lib/rest/types.js
// module id = 115
// module chunks = 0